module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/advantages_1_M3-e0e60ff33086f0dd247b103dad6504bd.webp";